export const CLOUD_PROD_URL = 'agami.mezzoforte.design'

export const CLOUD_BETA_URL = 'agami-beta.mezzoforte.design'

export const ROUTE_PROD_URL = 'route.mezzoforte.design'

export const ROUTE_BETA_URL = 'route-beta.mezzoforte.design'

export const ROUTE_LOCAL_URL = process.env.REACT_APP_ROUTE_LOCAL_URL ?? 'localhost:3000'
